import { __awaiter, __generator, __read } from "tslib";
import { useShellUtilitiesStore } from '@office-start/shell-utilities-store';
import { useEffect, useState } from 'react';
import { filter, take } from 'rxjs/operators';
import { getShellShim } from '../getShellShim';
/**
 * A hook that returns the shell shim when it is available.
 * This hook depends on Angular eventing and should only be used in the Angular application
 * @returns {ShellShimResult} shellShim: IO365ShellShim | undefined;
 *
 * use shellShimReact for retrieving shell shim information in the React application
 */
export var useShellShim = function () {
    var _a = __read(useState(false), 2), shellRenderedState = _a[0], setShellRenderedState = _a[1];
    var shellUtilitiesStoreReact = useShellUtilitiesStore();
    var _b = __read(useState(false), 2), shellPlusLoaded = _b[0], setShellPlusLoaded = _b[1];
    var _c = __read(useState(), 2), error = _c[0], setError = _c[1];
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                getShellShim().then(function () {
                    setShellRenderedState(true);
                    var eventService = window.ng2EventService;
                    if (eventService === null || eventService === void 0 ? void 0 : eventService.events) {
                        eventService.events
                            .withScope(0 /*PastAndFuture*/)
                            .pipe(filter(function (event) {
                            return (event === null || event === void 0 ? void 0 : event.name) === 'shellPlusLoaded';
                        }), take(1))
                            .toPromise()
                            .then(function () {
                            setShellPlusLoaded(true);
                            // $TODO: This block should move to ShellUtilitiesService
                            if (!shellUtilitiesStoreReact.loaded) {
                                shellUtilitiesStoreReact.setLoaded(true);
                            }
                        });
                    }
                }, function (reason) {
                    setError(reason);
                });
                return [2 /*return*/];
            });
        }); })();
    }, [shellUtilitiesStoreReact]);
    return {
        shellShim: shellRenderedState ? window.O365Shell : undefined,
        shellPlusLoaded: shellPlusLoaded,
        error: error,
    };
};
//# sourceMappingURL=useShellShim.js.map